import React, { useState } from 'react';
import styled from 'styled-components';
import { Button, Buttons, CancelButton, DayPickerInput, FormMessage, ModalCard } from '~/components';
import { useApi } from '~/contexts';
import { useForm } from '~/hooks';
import { weights } from '~/styles';

const Name = styled.p`
  margin-bottom: 1rem;

  > span {
    font-weight: ${weights.bold};
  }
`;

export default function SetTrial({ workspace, onChange, onClose }) {
  const [{ isSubmitting, message, status }, form] = useForm();
  const [trialEndsAt, setTrialEndsAt] = useState(workspace.billing?.trialEndsAt || null);
  const api = useApi();

  const handleSubmit = async (scope) => {
    form.submit(scope);

    try {
      await api.admin.workspaces.setTrial(workspace.id, trialEndsAt);

      onChange();
      onClose();
      form.done();
    } catch ({ message }) {
      form.error({ message });
    }
  };

  return (
    <ModalCard title="Set Trial End Date" onClose={onClose}>
      <ModalCard.Body>
        {status && <FormMessage.Error style={{ marginBottom: '1rem' }}>{message}</FormMessage.Error>}
        <Name>
          <span>{workspace.name}</span> ({workspace.key})
        </Name>
        <DayPickerInput value={trialEndsAt} placeholder="Trial end date" onChange={setTrialEndsAt} />
      </ModalCard.Body>
      <ModalCard.Footer>
        <Buttons align="right">
          <CancelButton onClick={onClose}>Cancel</CancelButton>
          <Button isLoading={isSubmitting} onClick={handleSubmit}>
            Save
          </Button>
        </Buttons>
      </ModalCard.Footer>
    </ModalCard>
  );
}
